import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrypto = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Crypto",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 2",
				cx: 24,
				cy: 12,
				r: 8,
				fill: "#EFB914"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Union",
				d: "M26.3395 9.14911C26.3739 9.17824 26.4073 9.20857 26.4408 9.23894C27.1374 9.87098 27.5891 10.7303 27.7147 11.665L26.3017 11.2864C26.1229 10.9203 25.9852 10.6696 25.5269 10.2538C25.0685 9.83784 24.4773 9.5982 23.859 9.57736C23.2409 9.55659 22.635 9.7561 22.1482 10.1401C21.6614 10.5241 21.325 11.0681 21.1988 11.6762C21.0726 12.2843 21.1652 12.917 21.4591 13.4626C21.7531 14.0083 22.2294 14.4321 22.8049 14.6583C23.3805 14.8846 24.0184 14.8995 24.6045 14.6997C25.1905 14.5 25.4515 14.1743 25.8115 13.908L27.1736 14.273C26.6865 15.0808 25.9308 15.6908 25.0402 15.9943C24.8858 16.0469 24.7286 16.0881 24.5704 16.1212L24.164 17.638L22.8755 17.2927L23.178 16.1636C22.9585 16.1312 22.7415 16.0792 22.5287 16.0099L22.2312 17.1201L20.9436 16.7751L21.3207 15.3677C20.8877 15.0306 20.5248 14.6061 20.2602 14.115C19.8136 13.2859 19.6737 12.3247 19.8653 11.4008C20.057 10.4767 20.568 9.64928 21.3078 9.06565C21.8405 8.64553 22.4669 8.37093 23.1267 8.26194L23.5389 6.72344L24.8265 7.06845L24.5027 8.2768C24.7222 8.3178 24.9374 8.37637 25.146 8.4532L25.4953 7.14958L26.7829 7.49459L26.3395 9.14911Z",
				fill: "#1A1A1A"
			})]
		})
	}) })
});
export default SvgCrypto;
